import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'fgb-faq-page',
  templateUrl: './faq-page.component.html',
  styleUrls: ['./faq-page.component.scss'],
})
export class FaqPageComponent implements OnInit {
  disabled = false;
  constructor() {}
  ngOnInit() {}
}
